// eslint-disable-next-line import/no-unresolved
import * as CSS from "csstype";
import React from "react";
import { v4 as uuid } from "uuid";
import styled from "styled-components";
import { FlexboxProps, SpaceProps, layout, LayoutProps, ResponsiveValue, TLengthStyledSystem } from "styled-system";
// import { Box } from "../Box";
import { Flex } from "../Flex";

interface Props {
  grid: ResponsiveValue<CSS.Property.FlexBasis<TLengthStyledSystem>>;
  children?: React.ReactNode[] | React.ReactNode;
}

const GridContainer = styled(Flex)`
  ${layout}
  flex-wrap: wrap
`;

export const Grid: React.FC<Props & FlexboxProps & SpaceProps & LayoutProps> = ({ grid, children, ...props }) => {
  return (
    <GridContainer {...props}>
      {children && Array.isArray(children) ? (
        children.map((child: React.ReactNode) => (
          // Key not relevant for static content - used to supress warnings.
          <Flex key={uuid()} maxWidth={grid} flexBasis={grid}>
            {child}
          </Flex>
        ))
      ) : (
        <Flex key={uuid()} maxWidth={grid} flexBasis={grid}>
          {children}
        </Flex>
      )}
    </GridContainer>
  );
};
